import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            <br />I am a <b>quick learner</b> with a strong <b>analytical mindset</b>, always eager to embrace new challenges and solve real-world problems. With a solid foundation in <b>technical expertise</b>, I am confident in my ability to take on dynamic and complex projects, particularly in the fields of <b>Data Science</b> and <b>Web-based Applications</b>.
            My adaptability allows me to seamlessly integrate into both team environments and independent tasks, while consistently achieving results. I am committed to mastering a diverse set of technologies to keep pace with the evolving demands of the industry. With a focus on continuous learning, I want to work with high-skilled professionals so that I could widen my knowledge by collaboration.
          </p>
          <br></br>

          <h5 className="purple"> Hobbies</h5>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Photography
            </li>
          </ul>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Wrting on Life Experience
            </li>
          </ul>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Connecting with multi-cultural people
            </li>
          </ul>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Play cricket, badminton, or other sports
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Software development is a journey where each line of code is a step of experience, and with every bug encountered, 
            we pave the path to innovation and mastery"{" "}
          </p>
          <footer className="blockquote-footer">Akash Debnath</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
